import { reactLocalStorage } from "reactjs-localstorage";
import { getCostingTypePermission } from '../../common/CommonFunctions';

export function Steps(t) {
    const permissions = getCostingTypePermission();
    return {
        ADD_FUEL: [
            {
                element: "#AddFuel_zerobased",
                intro: t("addfuel.AddFuel_zerobased"),
            },
            {
                element: "#AddFuel_vendorbased",
                intro: t("addfuel.AddFuel_vendorbased"),
            },
            ...(permissions?.cbc ? [{
                element: "#AddFuel_customerbased",
                intro: t("addfuel.AddFuel_customerbased"),
            }] : []),
            {
                element: "#AddFuel_plant_container",
                intro: t("addfuel.AddFuel_plant_container"),
            },
            {
                element: "#AddFuel_Fuel_container",
                intro: t("addfuel.AddFuel_Fuel_container"),
            },
            {
                element: "#AddFuel_Toggle",
                intro: t("addfuel.AddFuel_Toggle"),
            },
            {
                element: "#AddFuel_CountryId_container",
                intro: t("addfuel.AddFuel_CountryId_container"),
            },
            {
                element: "#AddFuel_StateId_container",
                intro: t("addfuel.AddFuel_StateId_container"),
            },
            {
                element: "#AddFuel_CityId_container ",
                intro: t("addfuel.AddFuel_CityId_container"),
            },
            {
                element: "#AddFuel_Rate",
                intro: t("addfuel.AddFuel_Rate"),
            },
            {
                element: "#AddFuel_EffectiveDate",
                intro: t("addfuel.AddFuel_EffectiveDate"),
            },
            {
                element: "#AddFuel_AddData",
                intro: t("addfuel.AddFuel_AddData"),
            },
            {
                element: "#AddFuel_Cancel",
                intro: t("addfuel.AddFuel_Cancel"),
            },
            {
                element: "#AddFuel_Save",
                intro: t("addfuel.AddFuel_Save"),
                position: 'left'
            },
        ],
        ADD_FUEL_NAME_DRAWERS: [
            {
                element: "#AddFuelNameDrawer_FuelName",
                intro: t("addfuelNameDrawers.AddFuelNameDrawer_FuelName"),
            },
            {
                element: "#AddFuelNameDrawer_UnitOfMeasurementId_container",
                intro: t("addfuelNameDrawers.AddFuelNameDrawer_UnitOfMeasurementId_container"),
            },
            {
                element: "#AddFuelNameDrawer_Cancel",
                intro: t("addfuelNameDrawers.AddFuelNameDrawer_Cancel"),
            },
            {
                element: "#AddFuelNameDrawer_Save",
                intro: t("addfuelNameDrawers.AddFuelNameDrawer_Save"),
                position: 'left'
            },
        ],
        ADD_POWER: [
            {
                element: "#AddPower_zerobased",
                intro: t("addPower.AddPower_zerobased"),
            },
            {
                element: "#AddPower_vendorbased",
                intro: t("addPower.AddPower_vendorbased"),
            },
            {
                element: "#AddPower_customerbased",
                intro: t("addPower.AddPower_customerbased"),
            },
            {
                element: "#AddPower_state_container",
                intro: t("addPower.AddPower_state_container"),
            },
            {
                element: "#AddPower_Plant_container",
                intro: t("addPower.AddPower_Plant_container"),
            },
            {
                element: "#AddPower_EffectiveDate",
                intro: t("addPower.AddPower_EffectiveDate"),
            },
            {
                element: "#AddPower_NetPowerCostPerUnit",
                intro: t("addPower.AddPower_NetPowerCostPerUnit"),
            },
            {
                element: "#AddPower_AddMoreDetails",
                intro: t("addPower.AddPower_AddMoreDetails"),
            },
            {
                element: "#AddPower_Cancel",
                intro: t("addPower.AddPower_Cancel"),
            },
            {
                element: "#AddPower_Save",
                intro: t("addPower.AddPower_Save"),
                position: 'left'
            },

        ],
    }
}